import * as React from 'react';

const SvgComponent = props => (
  <div className="relative flex flex-col items-center">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3517.067 1644.67" {...props}>
      <defs>
        <style>
          {
            '@font-face{font-family:"Virgil";src:url(https://excalidraw.com/Virgil.woff2)}@font-face{font-family:"Cascadia";src:url(https://excalidraw.com/Cascadia.woff2)}'
          }
        </style>
      </defs>
      <path
        d="M278.658 689.545c7.157 7.87 12.395 19.962 14.728 31.648 2.334 11.686 1.581 26.662-.714 38.46-2.308 11.806-6.786 22.71-13.094 32.35-6.307 9.641-15.144 19.16-24.75 25.486-9.604 6.317-22.021 10.666-32.89 12.453-10.86 1.788-21.225.303-32.296-1.719-11.081-2.024-24.533-3.928-34.15-10.425-9.626-6.5-17.773-18.63-23.578-28.575s-9.157-19.878-11.24-31.104c-2.094-11.219-3.712-25.202-1.294-36.211 2.43-11.016 9.204-20.804 15.84-29.875 6.625-9.073 14.52-18.083 23.96-24.572 9.45-6.497 21.499-11.766 32.696-14.379 11.204-2.6 23.534-3.611 34.503-1.244 10.962 2.355 20.555 4.419 31.293 15.403 10.736 10.993 27.303 37.362 33.123 50.517 5.82 13.154 2.884 28.458 1.799 28.398m-41.677-85.437c10.508 4.457 18.55 15.463 25.072 24.499 6.52 9.045 10.789 19.235 14.047 29.741 3.26 10.497 6.924 22.034 5.516 33.25-1.401 11.228-8.449 23.314-13.929 34.064-5.478 10.74-10.751 23.275-18.946 30.417-8.193 7.132-19.727 9.388-30.213 12.385-10.486 2.996-21.166 6.511-32.716 5.559-11.551-.943-26.532-6.083-36.606-11.25-10.071-5.176-16.956-10.753-23.801-19.772-6.857-9.012-13.69-22.795-17.322-34.334-3.634-11.53-5.409-24.235-4.483-34.887.914-10.644 4.39-19.338 9.996-29.011 5.606-9.672 15-21.381 23.638-29.004 8.64-7.633 17.379-13.116 28.2-16.794 10.82-3.677 25.74-6.174 36.74-5.289 10.99.883 24.265 8.467 29.25 10.596 4.985 2.13.622 1.154.636 2.184"
        stroke="#1864ab"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M123.668 712.269c.93-3.038 8.07-15.945 4.795-20.189-3.272-4.253-16.995-7.844-24.435-5.302-7.439 2.533-16.406 11.907-20.21 20.514-3.814 8.605-5.017 23.003-2.647 31.132 2.372 8.12 11.469 13.642 16.87 17.626 5.4 3.984 11.315 13.853 15.524 6.276 4.207-7.567 7.635-42.676 9.733-51.716m-2.618-.4c.815-3.898 8.218-19.322 6.25-22.528-1.98-3.199-10.952-.216-18.088 3.302-7.127 3.52-19.502 9.698-24.69 17.815-5.187 8.107-8.052 23.459-6.43 30.878 1.625 7.41 9.785 10.102 16.19 13.614 6.399 3.5 17.75 14.72 22.222 7.42 4.472-7.299 3.582-42.962 4.61-51.206M300.014 746.559c1.031-3.682.504-19.853 4.379-21.91 3.874-2.057 14.342 3.008 18.856 9.577 4.512 6.58 7.85 20.505 8.247 29.896.396 9.401-1.076 20.582-5.865 26.48-4.788 5.89-16.494 7.962-22.856 8.889-6.372.924-14.562 5.21-15.356-3.329-.784-8.537 9.264-39.385 10.622-47.9m.37-4.885c.745-3.472.595-15.528 4.3-16.607 3.707-1.08 13.347 3.441 17.926 10.129 4.577 6.697 9.164 20.897 9.546 30.007.382 9.11-1.995 19.728-7.231 24.69-5.244 4.95-17.448 5.075-24.22 5.042-6.783-.036-15.99 2.851-16.448-5.28-.469-8.134 11.12-36.709 13.685-43.502"
        stroke="#1864ab"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M116.556 688.292c2.407-8.957 3.336-39.425 14.97-53.493 11.634-14.068 36.939-26.724 54.845-30.912 17.904-4.177 35.369 1.148 52.577 5.816 17.22 4.662 38.427 12.46 50.688 22.169 12.261 9.709 18.74 24.95 22.883 36.065 4.142 11.116 1.726 21.159 1.987 30.61.25 9.45.225 21.032-.443 26.094M113.27 686.1c3.172-8.5 10.7-33.222 22.531-46.689 11.83-13.457 30.926-28.367 48.462-34.08 17.538-5.721 39.738-4.799 56.782-.22 17.042 4.589 34.278 17.647 45.48 27.712 11.202 10.056 16.789 22.107 21.748 32.634 4.967 10.54 7.579 19.733 8.045 30.578.467 10.846-5.018 29.208-5.231 34.52M100.782 751.991c-.014 3.202-2.422 14.563-.366 20.882 2.056 6.32 5.691 12.261 12.704 17.035 7.012 4.775 20.505 10.603 29.363 11.64 8.87 1.031 19.703-4.267 23.83-5.432M97.351 756.31c-.712 3.592-3.483 13.264-.075 19.645 3.396 6.389 12.48 15.195 20.49 18.654 8.02 3.46 19.993 1.697 27.586 2.088 7.58.398 14.871 1.242 17.924.276"
        stroke="#1864ab"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M182.603 790.395c3.573.883 6.62 2.69 8.816 4.141 2.205 1.455 4.451 2.867 4.365 4.583-.095 1.714-2.248 4.967-4.899 5.71-2.653.751-8.03-.628-11.031-1.232-3.011-.607-4.037-1.27-7.019-2.393-2.97-1.13-9.275-2.492-10.827-4.368-1.553-1.865.315-5.7 1.536-6.87 1.23-1.17 1.874-.587 5.82-.15 3.935.433 14.13 1.765 17.831 2.76 3.703.985 4.549 3.023 4.369 3.176m-13.978-5.562c2.85.024 8.495 1.795 11.541 2.646 3.058.843 6.09 1.013 6.794 2.432.703 1.419-.374 4.073-2.544 6.089s-7.044 5.44-10.483 5.997c-3.442.566-7.615-1.126-10.17-2.663-2.547-1.534-3.768-4.77-5.13-6.53-1.352-1.766-3.15-2.066-3.003-4.045.145-1.97 1.551-7.114 3.902-7.803 2.341-.692 8.117 3.092 10.172 3.659 2.065.568 2.653-.444 2.207-.251M152.06 721.175c.994-2.23 4.943-11.973 9.063-14.275 4.116-2.317 10.8-1.467 15.648.408 4.84 1.87 10.93 6.41 13.41 10.826 2.488 4.42 1.61 12.851 1.49 15.67m-41.527-16.459c1.926-2.493 13.017-9.457 17.758-11.901 4.735-2.435 6.307-4.164 10.654-2.724 4.352 1.432 13.665 6.276 15.442 11.339 1.777 5.063-4.658 15.472-4.762 19.05M57.903 886.863c64.67.28 123.79.17 274.02-1.5m-271.99 2.01c86.05 1.04 173.86 1.97 269.06-2.21m4.49 4.77c.11 63.15-2.2 126.9-.16 156.78m-2.76-162.65c.2 59-.64 120.13-.82 165.07m1.64-2.11c-106.86 3.31-206.16 5.45-270.51-1.63m268.2 3.19c-100.3-3.43-203.03-4.04-269.7-1.1m-.77 2.77c2.09-66.55-2.36-128.47.49-162.16m1.83 161.45c.28-57.99-.86-111.35-2.12-164.22M205.85 955.231c1.95 1.57 2.69 4.77 3.2 7.07.5 2.29 1.34 4.05-.17 6.71-1.52 2.67-5.83 8.36-8.91 9.28-3.07.92-7.11-2.34-9.54-3.77-2.43-1.44-3.67-2.45-5.05-4.83-1.38-2.37-3.98-6.92-3.26-9.41.73-2.5 4.99-4.24 7.61-5.55 2.63-1.31 4.71-3.08 8.16-2.3 3.44.78 10.3 5.07 12.51 6.97 2.22 1.9.98 4.19.79 4.42m-18.11-11.6c1.77-.84 3.44-.59 5.69.31 2.26.9 5.63 2.67 7.84 5.1 2.21 2.42 5.5 6.18 5.41 9.45-.09 3.27-3.11 8.18-5.94 10.15-2.83 1.98-8.11 2.43-11.05 1.69-2.93-.74-4.17-3.9-6.55-6.14-2.37-2.24-7.37-4.93-7.69-7.28-.32-2.35 3.72-4.02 5.76-6.81 2.04-2.78 5.09-8.52 6.49-9.9 1.4-1.39 2.22 1.22 1.92 1.58M257.879 751.685c-.178-2.33.28-13.911-1.43-18.24-1.703-4.32-4.258-6.534-8.831-7.695-4.564-1.152-14.43-1.235-18.592.754-4.15 1.99-4.828 8.516-6.337 11.193m32.203 12.475c-.42-2.97 1.546-16.257.166-21.083-1.379-4.835-4.125-7.958-8.441-7.898-4.317.06-13.038 5.593-17.459 8.242-4.411 2.659-7.986 5.665-9.036 7.68"
        stroke="#1864ab"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M330.735 1051.986c6.84.53 31.81.39 36.81 2.7 5 2.3 1.29 8.9-6.8 11.12-8.09 2.22-22.25 1.8-41.74 2.22-19.49.42-49.9.42-75.21.27-25.32-.14-43.17-.9-76.68-1.13-33.51-.23-98.7 2.85-124.4-.22-25.69-3.07-28.3-14.99-29.75-18.21-1.45-3.22 17-.8 21.03-1.1m294.38 2.54c6.8-.39 32.38-2.97 37.65.1 5.26 3.07 1.62 16.22-6.07 18.32-7.68 2.09-21.32-5.75-40.05-5.72-18.73.02-46.2 4.25-72.34 5.86-26.13 1.61-50.33 4.55-84.46 3.82-34.12-.73-94.79-3.95-120.31-8.19-25.51-4.24-31.97-14.14-32.8-17.24-.82-3.09 24.32-1.32 27.86-1.36M113.525 872.023c-4.36-.02-29.41 4.89-26.62.56 2.79-4.32 31.68-19.97 43.35-26.5 11.67-6.54 17.16-12.88 26.65-12.72 9.49.15 17.03 11.94 30.29 13.66 13.26 1.71 35.02.05 49.25-3.36 14.22-3.41 28.18-16.53 36.11-17.12 7.93-.59 6.42 6.29 11.46 13.59 5.05 7.3 21.48 23.95 18.81 30.21-2.66 6.26-23.13 6.65-34.82 7.33-11.68.69-29.38-2.41-35.29-3.22m-121.98-4.18c-4.69-.99-28.36 1.78-25.46-1.68 2.9-3.46 30.67-13.42 42.85-19.09s19.62-13.45 30.24-14.93c10.63-1.48 20.08 3.72 33.51 6.03 13.44 2.3 33.3 9.33 47.1 7.8 13.8-1.52 27.28-15.29 35.69-16.94 8.41-1.65 10.5.94 14.77 7.03 4.27 6.08 15.38 22.89 10.84 29.47-4.53 6.59-25.74 9.89-38.07 10.04-12.33.15-30.62-8.09-35.89-9.15"
        stroke="#1864ab"
        strokeWidth={2}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M849.629 356.16c-.21 213.08-1.07 1065.42-1.28 1278.51m1.28-1278.51c-.21 213.08-1.07 1065.42-1.28 1278.51"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(763.12 329.85)"
      >
        {'0ms'}
      </text>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(689.995 1411.112)"
      >
        {'1500ms'}
      </text>
      <g strokeLinecap="round">
        <path
          d="m444.006 322.155 207.35-.17-1.08 150.96-208.47 2.42"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M443.596 327.325c65.83-2.43 141.95-3.16 201.33-.67m-200.42-.36c53.86 2.62 108.69 1.83 205.42-1.23m.75.72c.82 59.88-3.74 118.34-4.61 146.31m3.88-147.04c-.66 59.16-2.27 114.66-1.53 148.58m2.58-2.08c-81.58-3.35-154.7-1.3-208.76-1.92m207.76 3.52c-51.11-2.04-100.75-.77-207.23-1.94m1.64-.43c-2.88-47.8 2.89-101.16-4.58-149.44m3.94 152.95c.51-45.06 1.23-87.67.05-148.74"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="M480.719 406.546c2.51-5.82 5.56-27.64 15.6-35.84 10.04-8.19 31.69-15.23 44.64-13.34 12.94 1.89 29.1 12.3 33.02 24.69 3.91 12.38-.94 39.52-9.54 49.61-8.59 10.09-31.16 10.84-42.04 10.93-10.89.09-19.45-8.71-23.26-10.38m-19.75-26.35c2.79-5.62 8.84-25.9 19.06-33.82 10.23-7.92 29.75-15.59 42.28-13.7 12.53 1.9 28.62 12.83 32.9 25.06 4.28 12.23 1.14 38.53-7.22 48.32s-31.91 10.48-42.95 10.41c-11.04-.07-19.25-9.29-23.31-10.84"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="m479.169 408.066-1.93-15.42 13.8 2.38-9.01 13.45"
          strokeWidth={0}
          fill="#1864ab"
          fillRule="evenodd"
        />
        <path
          d="M481.589 405.166c-2-2.8-2.98-10.96-2.13-14.05m1.7 15.93c-.13-3.44-.92-7.16-2.37-14.64m.25-.56c4.97 0 9.49 2.05 11.69 4.89m-11.92-4.73c3.97.54 6.76 1.9 12.41 4.02m-.78-1.32c-3.52 5.1-5.86 7.56-11.03 10.99m11.7-9.86c-2.92 2.83-4.76 4.89-11.04 11.04m.65-.33s0 0 0 0m0 0s0 0 0 0"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m452.89 1366.789 204.36 3.48-3.04 149.9-200.5-6.41"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M446.58 1368.919c63.55-2.85 114.39.42 207.42-.74m-202.96 3.51c50.79-2.93 100.93-3.96 206.01-.07m-1.16-.08c-2.81 39.69-1.1 78.17 3.1 145.85m-2.62-146.34c.82 51.45 1.45 107.72.39 146.78m-3.51-1.99c-41.98.84-90.03-2.62-205.42-.69m208.09 1.58c-56.65 2.12-114.92.14-205.3.22m-3.11 1.58c4.64-54.46-1.85-108.59 2.09-151.74m-.76 150.61c-.62-38.26.62-77.56 1.57-148.89"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(483.856 1398.113)"
      >
        {'hello'}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(483.856 1398.113)"
      >
        {'world!'}
      </text>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(707.708 841.087)"
      >
        {'800ms'}
      </text>
      <path
        d="M692.472 1513.772c2.94 3.36 8 27.02 18.23 25.21 10.24-1.8 35.3-30.56 43.17-36.03m-57 15.55c2.75 4.98 3.13 25.79 12.19 23.57 9.07-2.21 35.17-30.01 42.2-36.85"
        stroke="#1864ab"
        strokeWidth={4}
        fill="none"
        strokeOpacity={0.6}
        fillOpacity={0.6}
        strokeLinecap="round"
      />
      <path
        d="M834.472 358.233h13.7m-13.7 0h13.7M832.04 866.737h13.7m-13.7 0h13.7M836.468 1432.505h13.7m-13.7 0h13.7"
        stroke="#1864ab"
        strokeWidth={4}
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M1958.702 109.246c1.14 252.75 5.68 1263.77 6.82 1516.52m-6.82-1516.52c1.14 252.75 5.68 1263.77 6.82 1516.52"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1984.59 382.305)"
      >
        {'50ms'}
      </text>
      <path
        d="M1959.37 408.569h13.7m-13.7 0h13.7M2906.09 334.118c-.32 215.22-1.58 1076.08-1.9 1291.3m1.9-1291.3c-.32 215.22-1.58 1076.08-1.9 1291.3"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(2931.802 382.18)"
      >
        {'50ms'}
      </text>
      <path
        d="M2906.582 408.444h13.7m-13.7 0h13.7"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <g strokeLinecap="round">
        <path
          d="M2937.879 436.55c-.49 130.41-2.46 652.05-2.96 782.46m2.96-782.46c-.49 130.41-2.46 652.05-2.96 782.46M2952.879 436.61c-5.41-.02-10.82-.04-15-.06m15 .06c-5.94-.03-11.89-.05-15-.06"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M2922.879 436.49c5.41.02 10.82.04 15 .06m-15-.06c5.94.03 11.89.05 15 .06M2919.919 1218.95c5.41.02 10.82.04 15 .06m-15-.06c5.95.02 11.89.05 15 .06M2949.919 1219.06c-5.41-.02-10.82-.04-15-.05m15 .05-15-.05"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={36}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="rotate(89.213 1221.721 1801.29)"
      >
        {'Server thinking \u23F3'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M886.526 341.97c92.89-31.52 382.56-192.88 558.07-188.1 175.51 4.77 412.44 180.97 495.01 216.76m-1051.11-26.54c92.7-31.41 379.97-193.38 555.07-189.24 175.1 4.13 412.66 178.3 495.51 214.03"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M1907.856 363.94c9.34 2.62 22.53 4.76 29.77 3.04m-28.68-2.44c11.19 2.28 21.23 3.28 29.15 4.77"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M1917.806 345.99c6.14 8.35 16.14 16.25 19.82 20.99m-18.73-20.39c7.93 8.36 14.54 15.54 19.2 22.72"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1370.224 48.309 297.73 6.5 2.26 165.67-305.34-4.04"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1366.114 48.829c92.93 8.86 185.32 3.95 298.73 3.88m-297.84-.62c118.12 1.95 234.78.09 301.23.36m2.27 2.77c-1.08 42.25-6.65 98.85-5.86 159.55m1.75-164.97c2.39 37.27 3.34 73.98.13 167.67m2.22.76c-98.92-.83-192.97 4.1-300.46-.96m298.84 1.28c-79.16-1.05-160.16-2.49-300.55.61m-1.08-1.74c-.67-59.5 2.56-118.95 1.25-165.14m-.29 167.62c.12-52.38-1.53-107.89.84-169.67"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1409.083 89.434)"
      >
        {'GET '}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1409.083 89.434)"
      >
        {'example.com'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M1939.403 462.667c-106.57-.8-465.76-18.61-639.41-4.78-173.66 13.82-335.44 73.11-402.52 87.73m1041.93-82.95c-106.57-.8-465.76-18.61-639.41-4.78-173.66 13.82-335.44 73.11-402.52 87.73"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="m897.473 545.617 11.45-9.68 3.33 12.23-14.78-2.55"
          strokeWidth={0}
          fill="#1864ab"
          fillRule="evenodd"
        />
        <path
          d="M897.473 545.617c3.76-3.18 7.52-6.36 11.45-9.68m-11.45 9.68c4.07-3.45 8.15-6.9 11.45-9.68m0 0 3.33 12.23m-3.33-12.23c.88 3.22 1.75 6.45 3.33 12.23m0 0c-5.01-.86-10.01-1.72-14.78-2.55m14.78 2.55c-3.09-.53-6.17-1.06-14.78-2.55m0 0s0 0 0 0m0 0s0 0 0 0"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1225.355 311.564 465.26 5.35.4 227.93-465.41-2.24"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1228.945 314.274c126.84-1.21 255.05.65 464.03.19m-465.69-.17c165.68-2.96 329.34-1.45 465.61-.99m2.45-.04c.88 77.2 3.27 149.77-5.93 226.74m3.26-227.27c2.72 57.83 1.84 117.93-.44 229.17m-.82-1.85c-94.52-.71-189.94 1.88-465.55-.48m466.57 1.79c-141.89-1.43-284.25-.25-464.31-1.04m-.48 3.6c1.67-86.43.23-166.84.11-231.63m.18 227.87c2.09-80.06 1.59-159.19-2-226.26"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={36.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1261.815 335.724)"
      >
        {'HTTP 103'}
      </text>
      <text
        y={81}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1261.815 335.724)"
      >
        {'....'}
      </text>
      <text
        y={125.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1261.815 335.724)"
      >
        {'Link: </index.css>;'}
      </text>
      <text
        y={170}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={37.297}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1261.815 335.724)"
      >
        {'...'}
      </text>
      <text
        y={35}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(712.652 519.408)"
      >
        {'300ms'}
      </text>
      <path
        d="M835.72 545.058h13.7m-13.7 0h13.7"
        stroke="#1864ab"
        strokeWidth={4}
        fill="none"
        strokeLinecap="round"
      />
      <g strokeLinecap="round">
        <path
          d="M1961.865 380.652c155.83 7.4 780.95 37.86 936.78 45.5m-934.92-43.46c155.67 7.61 778.61 37.42 934.55 44.96"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M2867.815 438.372c12.95-6.35 24.75-10.09 29.27-11.6m-28.11 10.07c7.68-2.9 13.33-4.5 30.03-9.22"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M2868.795 417.872c12.56 1.71 23.98 6.02 28.29 8.9m-27.12-10.43c7.51 2.01 12.93 5.31 29.04 11.28"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m2266.641 270.106 303.07 2.57.74 160.73-305.09 1.6"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M2268.601 269.936c85.11-2.09 179.03-3.46 297.65 1.06m-299.8-2.1c82.54-4.02 165.8-2 299.2-.77m1.36 4.52c.03 45.96 4.37 103.55 3.5 163.13m-5.43-166.55c4.29 63.52 3.06 128.8.4 167.13m-.39-1.41c-103.05-.1-210.96.79-298.72.55m299.9.76c-110.83.45-222.22-1.96-301.19.64m2.53 1.09c1.13-51.43-2.48-101.94-4.63-166.05m3.13 165.04c-1.02-68.92-1.29-134.19-1.67-169.19"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(2308.31 306.97)"
      >
        {'GET '}
      </text>
      <text
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(2308.31 306.97)"
      >
        {'example.com'}
      </text>
      <g strokeLinecap="round">
        <path
          d="M1941.522 764.752c-68.25 14.22-231.07 68.65-408.4 84.21-177.32 15.56-546.44 7.64-655.56 9.16"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
          strokeOpacity={0.6}
          fillOpacity={0.6}
        />
        <g strokeOpacity={0.6} fillOpacity={0.6}>
          <path
            d="m877.972 857.422 12.93-4.33 1.51 11.13-15.5-5.93"
            strokeWidth={0}
            fill="#1864ab"
            fillRule="evenodd"
          />
          <path
            d="M877.602 858.892c3.29-2.29 7.22-3.25 12.07-7.2m2.31.79c.37 2-1.37 3.64-.28 11.44m-1.57 1.98c-4-3.2-8.94-6.8-11.14-8.47m-1.43.69s0 0 0 0"
            stroke="#1864ab"
            strokeWidth={1.5}
            fill="none"
          />
        </g>
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6} strokeLinecap="round">
        <path
          d="m1079.636 723.9 305.09 3.06-3.11 162.93-300.25 1.93"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1082.536 722.42c62.82-.87 128.44-1.01 299.39-.46m2.34 6.31c-1.35 40.27-4.77 89.35-3.9 166.03m4.55-2.82c-107.06-2.62-214.96-.49-305.24-.44m4.92 2.86c-5.75-35.88-2.39-75.29-5.1-168.64"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
        />
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6}>
        <text
          y={35.5}
          fontFamily="Cascadia, Segoe UI Emoji"
          fontSize={36}
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1124.083 761.577)"
        >
          {'HTTP 200 OK '}
        </text>
        <text
          y={79}
          fontFamily="Cascadia, Segoe UI Emoji"
          fontSize={36}
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1124.083 761.577)"
        >
          {'/index.css'}
        </text>
      </g>
      <g strokeLinecap="round">
        <path
          d="M876.486 574.425c178.41 14.07 892.03 70.34 1070.44 84.41"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
          strokeOpacity={0.6}
          fillOpacity={0.6}
        />
        <g strokeOpacity={0.6} fillOpacity={0.6}>
          <path
            d="m1946.926 658.835-14.05 5.25.99-12.64 13.06 7.39"
            strokeWidth={0}
            fill="#1864ab"
            fillRule="evenodd"
          />
          <path
            d="M1946.926 658.835c-4.25 1.59-8.5 3.18-14.05 5.25m0 0 .99-12.64m0 0c3.03 1.72 6.06 3.43 13.06 7.39m0 0s0 0 0 0"
            stroke="#1864ab"
            strokeWidth={1.5}
            fill="none"
          />
        </g>
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6} strokeLinecap="round">
        <path
          d="m1589.135 541.567 297.3.87 1.94 166.82-303.09-3.08"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1583.835 544.867c105.7-4.11 211.98-4.64 304.73-.9m-2.44-5.46c6.55 60.66 7.92 123.32.78 167.63m1.49 1.65c-116.6 1.62-238.28.56-302.19 1.28m3.56.5c-5.34-67.14-4.59-131.89-3.69-164.9"
          stroke="#1864ab"
          strokeWidth={1.5}
          fill="none"
          strokeDasharray="8 9"
        />
      </g>
      <g strokeOpacity={0.6} fillOpacity={0.6}>
        <text
          y={35.5}
          fontFamily="Cascadia, Segoe UI Emoji"
          fontSize={36}
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1629.204 579.714)"
        >
          {'GET '}
        </text>
        <text
          y={79}
          fontFamily="Cascadia, Segoe UI Emoji"
          fontSize={36}
          fill="#1864ab"
          style={{
            whiteSpace: 'pre',
          }}
          transform="translate(1629.204 579.714)"
        >
          {'/index.css'}
        </text>
      </g>
      <g strokeLinecap="round">
        <path
          d="M2888.85 1241.16c-335.74 32.5-1679.56 160.76-2015.45 193.09m2011.96-195.19c-335.96 31.75-1678.29 158.76-2013.83 190.68M899.61 1417.83c-6.88 3.55-12.75 7.54-29.85 11.76m27.62-11.15c-5.18 2.79-13.45 4.43-26.09 10.78"
          stroke="#1864ab"
          fill="none"
        />
        <path
          d="M901.55 1438.26c-7.21-1.81-13.58-3.17-31.79-8.67m29.56 9.28c-5.46-2.48-14.23-6.1-28.03-9.65"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="m1648.972 1136.79 866.81 3.55 5.27 269.8-868.51 4.41"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M1652.452 1139.69c221.29-1.21 442.75-2.94 867.19-1.21m-866.95.96c213.99 3.8 427.49 3.95 866.8.42m-.92-3.29c1.03 70 2.39 138.96-1.24 272.48m1.57-269.15c-.72 101.9-1.17 204.01-.25 271.79m-.5-2.51c-304.83-2.44-612.86-2.66-864.82 1.19m866.24 1.04c-297.1.47-593.94 1.57-867.45-.92m-1.45 2.29c2.53-63.18 6.48-127.86 3.03-275.91m-2.69 272.4c1.34-79.33 1.89-158.29.66-269.99"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <text
        y={33.6}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={34.566}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1684.265 1176.565)"
      >
        {'HTTP 200 OK'}
      </text>
      <text
        y={75.2}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={34.566}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1684.265 1176.565)"
      >
        {'....'}
      </text>
      <text
        y={116.8}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={34.566}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1684.265 1176.565)"
      >
        {'<link rel="preload" src="/index.css" />'}
      </text>
      <text
        y={158.4}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={34.566}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1684.265 1176.565)"
      >
        {'...'}
      </text>
      <text
        y={200}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={34.566}
        fill="#1864ab"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1684.265 1176.565)"
      >
        {'<p>hello world!</p>'}
      </text>
      <text
        x={84.5}
        y={35.5}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        textAnchor="middle"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1882.163 10)"
      >
        {'CDN Edge'}
      </text>
      <text
        x={84.5}
        y={79}
        fontFamily="Cascadia, Segoe UI Emoji"
        fontSize={36}
        fill="#1864ab"
        textAnchor="middle"
        style={{
          whiteSpace: 'pre',
        }}
        transform="translate(1882.163 10)"
      >
        {'Server'}
      </text>
      <g fillRule="evenodd" strokeLinecap="round">
        <path
          d="M3224.467 677.738v269.59l-.96 33.41-.14-2.51 6.85 6.67 17.04 11.61 40.38 7.56 42.62.35 40.13 1.45 43.11-.06 36.96-5.81 28.47-5.65 20.58-8.13.26-11.76 1.81 2.09-2.15-301.58 1.53 2-7.3-7.52-11.81-4.04-24.56-6.33-55.41-5.48-42.98-5.27-36.22 2.76-30.96 2.14-32.28 7.55-23.34 7.14-4.95 1.92-5.3 10.87.54-.77"
          strokeWidth={0}
          fill="#e7f5ff"
        />
        <path
          d="M3225.867 678.958c.22 45.08.39 219.52.32 269.42-.08 49.9-2.8 22.61-.79 30 2.02 7.38 2.33 10.35 12.88 14.32 10.54 3.97 28.25 7.08 50.37 9.51 22.12 2.43 55.08 5.46 82.35 5.06 27.26-.41 60.75-4.38 81.27-7.49 20.52-3.1 33.78-7.01 41.86-11.13 8.07-4.12 5.53-7.23 6.59-13.59 1.06-6.36-.23 20.96-.24-24.59 0-45.54.58-203.05.23-248.71s.8-18.86-2.34-25.25c-3.13-6.38-7.25-9.85-16.46-13.06-9.21-3.2-18.48-4.04-38.81-6.18-20.32-2.14-57.76-6.25-83.15-6.65-25.39-.4-48.62 1.42-69.18 4.25-20.56 2.83-42.99 8.8-54.17 12.74-11.18 3.94-10.99 9.06-12.9 10.91-1.92 1.84 1.09.22 1.41.18m-.26-.45c.11 44.76.53 218.1.52 268.33-.01 50.24-2.67 25.74-.56 33.08 2.11 7.35 2.8 7.25 13.2 11.01 10.39 3.76 26.88 8.9 49.18 11.57s56.97 4.56 84.62 4.44c27.66-.11 61.1-2.17 81.3-5.13 20.2-2.96 32.22-8.49 39.92-12.63 7.69-4.14 4.95-6.24 6.27-12.21 1.32-5.96 1.32 22.61 1.63-23.59.32-46.2.35-207.36.25-253.6-.1-46.23 2.25-17.62-.86-23.82-3.11-6.2-8.7-10.35-17.81-13.37-9.11-3.02-15.97-2.79-36.85-4.77-20.87-1.98-62.79-6.37-88.41-7.12-25.62-.76-44.97.16-65.31 2.61-20.34 2.45-45.64 7.74-56.73 12.08-11.08 4.34-7.86 11.6-9.76 13.94-1.91 2.33-1.85-.1-1.68.08"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <path
        d="M3230.043 883.522c1.39 1.95.94 8.76 7.27 12.31 6.34 3.54 18.47 6.26 30.74 8.95 12.27 2.69 25.1 6.1 42.87 7.2 17.78 1.1 40.16-.07 63.78-.58 23.63-.5 57.87.45 77.99-2.44 20.12-2.89 33.66-10.47 42.73-14.91 9.06-4.44 10.09-9.58 11.64-11.71m-278.14.26c1.32 1.5 1.38 7.45 7.77 11.28 6.39 3.83 18.06 8.5 30.57 11.7 12.5 3.2 26.23 6.57 44.44 7.51 18.21.93 41.63-1.06 64.83-1.89 23.2-.83 54.54.01 74.37-3.08 19.83-3.1 35.32-11.18 44.61-15.49 9.3-4.31 9.38-8.81 11.14-10.38M3225.705 778.65c1.13 1.92 1.12 7.74 7.36 11.55 6.25 3.81 17.96 8.69 30.11 11.33 12.15 2.64 24.93 3.4 42.79 4.51 17.86 1.1 40.63 2.75 64.35 2.13 23.71-.63 57.59-2.86 77.93-5.86 20.34-3.01 35.08-7.72 44.11-12.2 9.03-4.47 8.57-12.25 10.07-14.67m-278.05 2.49c.92 2.07 1.05 10.15 7.92 13.78 6.86 3.63 20.94 5.5 33.26 8.01 12.32 2.51 22.94 5.51 40.66 7.06 17.73 1.55 42.36 2.63 65.69 2.23 23.33-.4 54.12-1.36 74.29-4.63 20.17-3.27 37.48-10.63 46.73-15 9.24-4.38 7.04-9.23 8.72-11.25"
        stroke="#1864ab"
        fill="none"
        strokeLinecap="round"
      />
      <g strokeLinecap="round">
        <path
          d="M3395.05 651.423c16.85.44 34.86 3.32 49.02 5.57 14.15 2.25 27.06 4.95 35.9 7.94 8.84 2.98 14.55 6.72 17.13 9.95 2.58 3.23 2.61 6.04-1.65 9.42-4.26 3.39-13.47 7.79-23.92 10.9-10.46 3.12-23.76 6.11-38.81 7.78s-34.31 2-51.51 2.24c-17.21.23-34.79-.05-51.72-.82-16.93-.78-35.69-1.75-49.85-3.84-14.16-2.09-26.02-5.77-35.11-8.7-9.08-2.92-16.66-5.48-19.4-8.85-2.75-3.36-1.49-7.97 2.95-11.35s13.24-6.11 23.7-8.93c10.45-2.83 24.16-6.24 39.02-8.03 14.86-1.79 31.7-2.21 50.13-2.71 18.42-.5 49.22-.45 60.42-.29 11.2.15 7.38.86 6.77 1.22m-111.52 1.76c13.7-2.05 33.44-2.77 50.81-3.23 17.37-.45 36.56-.53 53.42.52 16.87 1.04 34.18 3.79 47.78 5.76 13.6 1.97 25.44 3.27 33.81 6.08 8.37 2.81 14.83 6.97 16.42 10.78 1.58 3.8-2.02 8.54-6.9 12.04-4.88 3.49-11.56 6.2-22.39 8.93-10.83 2.72-27.21 5.79-42.61 7.42-15.41 1.64-32.63 2.24-49.84 2.38-17.21.14-36.5-.47-53.43-1.55-16.94-1.08-34.28-2.82-48.15-4.94-13.88-2.12-26.64-4.91-35.09-7.78-8.46-2.88-14.01-5.9-15.63-9.48-1.62-3.58.64-8.69 5.91-12.02 5.27-3.32 14.6-5.37 25.68-7.92 11.09-2.54 34.01-6.41 40.81-7.35 6.79-.94-.84 1.43-.03 1.69"
          strokeWidth={0}
          fill="#fff"
        />
        <path
          d="M3358.5 650.123c16.55-.53 35.41 1.93 51.79 3.16 16.38 1.23 33.66 1.73 46.47 4.21 12.8 2.49 23.26 7.48 30.36 10.69 7.09 3.22 11.85 5.39 12.2 8.62.35 3.22-3.75 7.17-10.09 10.76-6.34 3.58-15.87 8.12-27.94 10.72-12.08 2.61-28.56 3.69-44.51 4.92-15.95 1.24-33.66 2.2-51.19 2.51-17.52.31-37.7.48-53.96-.62-16.26-1.1-31.05-3.56-43.58-5.97-12.53-2.42-24.3-5.3-31.58-8.52-7.28-3.22-11.5-7.17-12.11-10.82-.62-3.64 2.06-7.69 8.42-11.06 6.35-3.36 17.4-6.51 29.73-9.12 12.33-2.62 25.7-5.06 44.25-6.58 18.56-1.51 53.5-2.28 67.09-2.51 13.59-.24 14.71.44 14.46 1.09m-58.21-1.01c15.86-1.44 38.24-1.21 55.81-.26 17.58.94 35.19 4.14 49.64 5.93 14.46 1.79 27.17 2.27 37.09 4.8 9.93 2.53 18.26 6.89 22.47 10.38 4.21 3.49 5.75 6.78 2.79 10.56-2.96 3.78-11.07 8.81-20.54 12.12-9.46 3.31-22.26 5.95-36.25 7.74-14 1.8-30.55 2.29-47.71 3-17.15.72-37.6 1.95-55.21 1.3-17.6-.65-35.79-3.39-50.42-5.2-14.63-1.81-27.23-3.1-37.34-5.65-10.12-2.56-19.32-6.17-23.34-9.67s-4.02-7.72-.78-11.35c3.25-3.62 10.79-7.14 20.24-10.39 9.46-3.25 22.25-7.03 36.49-9.1 14.24-2.06 41.06-2.82 48.98-3.3 7.91-.48-1.89-.14-1.47.44"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="M3475.356 728.26c3.92 1.04 7.68 5.88 9.75 9.79 2.06 3.92 3.11 9.01 2.66 13.7-.45 4.68-2.18 11.03-5.35 14.4-3.17 3.36-9.3 5.65-13.69 5.8-4.38.15-9.4-1.95-12.59-4.9-3.2-2.95-5.74-8.08-6.56-12.81-.81-4.74-.31-11.46 1.67-15.61 1.99-4.15 6.26-7.73 10.27-9.29 4-1.57 11.1-.36 13.77-.1 2.66.26 2.25 1.37 2.22 1.65m-3.75-2.74c4.34.88 9.63 5.78 12.27 9.78 2.64 4.01 4.18 9.65 3.59 14.24-.58 4.59-4.08 10.34-7.1 13.3-3.03 2.96-6.71 4.05-11.07 4.47-4.35.42-11.39.27-15.05-1.95-3.67-2.21-5.64-6.6-6.93-11.33-1.28-4.73-2.67-12.34-.77-17.05 1.91-4.71 8.23-9.28 12.19-11.22 3.96-1.94 9.44-.24 11.58-.42 2.15-.17 1.47-1.12 1.31-.61"
          strokeWidth={0}
          fill="#fff"
        />
        <path
          d="M3459.976 728.49c3.63-1.97 10.95-1.1 15.03.38 4.08 1.47 7.05 4.55 9.46 8.47 2.41 3.91 5.53 10.46 5.02 15.04-.52 4.58-4.68 9.26-8.12 12.44-3.44 3.19-8.51 6.39-12.53 6.67-4.03.28-8.19-2.25-11.6-4.98-3.41-2.73-7.69-6.83-8.88-11.4-1.19-4.58-.9-11.76 1.73-16.05 2.63-4.29 11.24-7.92 14.05-9.69 2.8-1.77 2.68-1.1 2.8-.95m8.43.94c4.32 1.14 9.19 5.1 11.29 8.98 2.09 3.88 2.32 9.73 1.3 14.3-1.03 4.56-4.12 9.8-7.47 13.11-3.36 3.31-8.43 6.59-12.66 6.76-4.24.18-9.74-2.38-12.77-5.73-3.02-3.35-4.6-9.91-5.4-14.38-.8-4.47-1.27-8.67.58-12.42s6.12-8.08 10.51-10.08c4.4-2.01 13.66-1.8 15.84-1.97 2.18-.16-2.3.33-2.77.98"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="M3467.336 823.035c4.03-.69 10.39 1.3 13.75 4.29 3.37 3 5.48 9.1 6.44 13.69.97 4.58 1.12 9.77-.67 13.83-1.78 4.07-6.01 8.56-10.04 10.54-4.02 1.99-9.9 2.7-14.09 1.38-4.19-1.33-8.6-5.36-11.06-9.33-2.47-3.97-4.3-9.66-3.73-14.51.57-4.85 3.28-11.42 7.15-14.59 3.88-3.18 12.76-3.83 16.08-4.46 3.31-.62 3.91.31 3.8.71m-10.33.49c4.05-1 11.04.18 15.03 2.18 3.98 1.99 7.42 5.44 8.88 9.77 1.45 4.33 1.67 11.88-.16 16.22-1.82 4.35-7.01 7.56-10.78 9.87-3.78 2.3-8.01 4.81-11.87 3.97-3.85-.84-8.22-5.61-11.27-9-3.05-3.39-6.54-6.73-7.04-11.32-.49-4.58 1.22-12.45 4.06-16.19 2.84-3.74 10.97-4.96 12.98-6.24 2-1.29-1.19-1.62-.97-1.46"
          strokeWidth={0}
          fill="#fff"
        />
        <path
          d="M3475.816 826.085c3.89 1.51 9.11 4.56 11.13 8.81 2.02 4.25 2.01 12.17.97 16.68-1.03 4.52-3.64 7.98-7.2 10.41-3.55 2.43-9.8 4.23-14.13 4.17-4.32-.05-8.73-1.31-11.82-4.52-3.08-3.21-6.33-9.89-6.71-14.74-.38-4.84 2.03-10.69 4.42-14.33 2.39-3.64 5.55-6.5 9.93-7.51 4.38-1.02 13.61.96 16.32 1.41 2.71.44.31.94-.04 1.28m-19.22-.9c3.4-2.44 9.02-3.99 13.09-3.35 4.07.63 8.69 3.56 11.32 7.15 2.62 3.6 4.29 9.66 4.44 14.4.15 4.75-.81 10.29-3.54 14.08-2.73 3.79-8.21 7.99-12.85 8.65-4.64.65-11.45-1.99-14.99-4.72-3.53-2.73-5.19-7.59-6.22-11.67-1.04-4.09-1.21-8.41.01-12.84 1.22-4.44 5.97-11.64 7.31-13.79 1.35-2.15.3.52.76.88"
          stroke="#1864ab"
          fill="none"
        />
      </g>
      <g strokeLinecap="round">
        <path
          d="M3473.406 928.604c3.78.86 8.38 3.84 10.97 7.73 2.58 3.9 4.92 10.75 4.54 15.63-.38 4.88-3.69 10.39-6.83 13.64-3.14 3.26-7.92 5.6-12 5.89-4.08.3-9.06-1.26-12.48-4.12-3.41-2.87-6.9-8.56-8.01-13.09-1.11-4.54-.27-10.01 1.35-14.12 1.63-4.11 4.03-8.9 8.4-10.57 4.36-1.66 14.47.29 17.78.57 3.32.28 2.21.95 2.11 1.12m-3.86-1.51c4.11 1.2 8.79 4.9 10.89 8.71 2.11 3.81 2.26 9.91 1.76 14.16-.51 4.24-1.6 8.14-4.78 11.3s-9.91 6.97-14.29 7.67c-4.39.71-8.47-.43-12.04-3.43-3.56-3-8.49-9.58-9.36-14.56-.88-4.98 2.13-11.23 4.12-15.31 1.99-4.08 4.01-7.31 7.83-9.17 3.83-1.87 12.94-2.09 15.13-2.03 2.19.07-1.7 1.88-2 2.43"
          strokeWidth={0}
          fill="#fff"
        />
        <path
          d="M3469.336 927.914c4.04-.13 7.99 1.68 11.32 4.72 3.33 3.03 7.95 8.93 8.67 13.47.71 4.54-1.92 9.78-4.4 13.79-2.47 4.02-6.7 8.71-10.47 10.3-3.78 1.59-8.18.79-12.17-.76-4-1.56-9.48-4.5-11.82-8.58-2.33-4.09-3.19-11.4-2.2-15.93 1-4.53 4.18-8.46 8.16-11.28 3.99-2.81 12.61-4.78 15.76-5.59 3.15-.81 3.17.57 3.14.73m-3.1-1.02c4 .22 8.36 3.25 10.91 6.69 2.55 3.45 4.35 9.05 4.4 14 .05 4.95-1.5 11.91-4.1 15.72-2.6 3.8-7.57 6.53-11.5 7.1-3.92.57-8.23-1.58-12.04-3.67-3.82-2.08-8.98-4.82-10.85-8.85-1.86-4.02-2.06-10.5-.36-15.31 1.71-4.81 7.04-10.89 10.61-13.56 3.58-2.67 8.96-2.33 10.84-2.46 1.88-.13.45 1.37.44 1.69"
          stroke="#1864ab"
          fill="none"
        />
      </g>
    </svg>
    <span className="text-sm italic">Early Hints with a CDN Edge Server</span>
  </div>
);

export default SvgComponent;
